import React from 'react'
import Navbar from '../../Components/Navbar/Navbar'
import Footer from '../../Components/Footer/Footer'

function Gallery() {
  return (
    <div>
      <Navbar></Navbar>
      <h1>This is Gallery</h1>
      <Footer></Footer>
    </div>
  )
}

export default Gallery
